import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`   
   .select {
      &:not(:last-of-type) {
         margin-bottom: 10px;
      }
      h4 { 
         width: 80px; 
      }
   }
   
   .textInput {
      h4 {
         width: 100px;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
   }
   
   > .scroll {
      overflow: auto;
      max-height: 280px;
      padding-right: 10px;
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid rgba(200, 200, 200, 0.3);
   }
   
   .authSelect {
      margin-bottom: 16px;
   }
`;